// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Footer-module--wrap--B-ZZY","inner":"Footer-module--inner--2Dbxr","logo":"Footer-module--logo--30xFU"};